// HomeworkFilter.jsx
import React, { useMemo } from "react";
import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";

const HomeworkFilter = ({
  programData = [],
  filters,
  onFilterChange,
  onSearch,
  onReset,
}) => {
  const subjectOptions = useMemo(() => {
    return (
      programData.find(
        (p) => p.id === Number(filters.program_id)
      )?.subjects || []
    );
  }, [programData, filters.program_id]);

  return (
    <div className="row mb-3">
      <div className="col-md-4">
        <Input
          name="homework_title"
          placeholder="Homework Title"
          value={filters.homework_title}
          onChange={onFilterChange}
        />
      </div>

      <div className="col-md-4">
        <Select
          name="program_id"
          placeholder="Select Class"
          value={filters.program_id}
          options={programData}
          onChange={onFilterChange}
        />
      </div>

      <div className="col-md-4">
        <Select
          name="subject_id"
          placeholder="Select Subject"
          value={filters.subject_id}
          options={subjectOptions}
          onChange={onFilterChange}
        />
      </div>

      <div className="col-md-4 mt-2">
        <Select
          name="homework_type"
          placeholder="Homework Type"
          value={filters.homework_type}
          onChange={onFilterChange}
          options={[
            { id: "", name: "All" },
            { id: "daily", name: "Daily" },
            { id: "weekly", name: "Weekly" },
          ]}
        />
      </div>

      <div className="col-md-4 mt-2">
        <Button variant="success" onClick={onSearch}>
          Search
        </Button>
        <Button variant="secondary" onClick={onReset} className="mx-2">
          Reset
        </Button>
      </div>
    </div>
  );
};

export default HomeworkFilter;
